import React from "react";
import "./App.css";
import Gitnewapi from "./Gitnew";

function App() {
  return (
    <>
      <div>
        {/* <Githubapi /> */}
        <Gitnewapi />
      </div>
    </>
  );
}

export default App;
